const faqs = [
  {
    question: "Does Nebraska have its own regional passport agency?",
    answer:
      "No — Nebraska does not have a regional passport agency within state borders. The closest regional passport agency is the Chicago Passport Agency in downtown Chicago, approximately 460 miles from Omaha. The Denver Passport Agency is also an option for western Nebraska residents. Using a registered courier like Fast Passport Center is often faster and eliminates the need for an in-person agency visit.",
  },
  {
    question: "How fast can I get a passport in Nebraska?",
    answer:
      "With Fast Passport Center's courier service, Nebraska travelers can receive a passport in as little as 24 hours. Our standard expedited service ranges from 3 to 9 business days. Routine processing through the post office typically takes 6 to 13 weeks.",
  },
  {
    question: "Do I need to visit a passport acceptance facility in Nebraska?",
    answer:
      "First-time applicants, minors, and those replacing lost or stolen passports must visit an acceptance facility (typically a post office, county clerk, or city hall). Renewals for adults can usually be done by mail without an in-person visit.",
  },
  {
    question: "Which airport should I fly from with an expired passport?",
    answer:
      "If your passport is expired or soon to expire, you should not book international travel until you have a valid passport in hand. Eppley Airfield (OMA) in Omaha is Nebraska's primary airport. Lincoln Airport (LNK) and Minneapolis-Saint Paul (MSP) are also used by Nebraska residents.",
  },
  {
    question: "Can I renew by mail from Nebraska?",
    answer:
      "Yes — if your most recent passport was issued when you were 16 or older, was issued within the last 15 years, and is undamaged, you can renew by mail using Form DS-82. Mail your application to the National Passport Processing Center. For faster processing, use a registered courier service.",
  },
  {
    question: "Where is the best place to get a passport photo in Nebraska?",
    answer:
      "CVS, Walgreens, UPS Store, FedEx Office, and Walmart locations across Nebraska offer passport photo services. Most locations can take photos on a walk-in basis. Always verify the photo meets State Department requirements (2×2 inches, white background, taken within 6 months) before submitting.",
  },
];

export { faqs };

export default function NEFAQSection() {
  return (
    <section id="faq" className="bg-[#F7F8FA] py-20 md:py-28">
      <div className="max-w-3xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">FAQ</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            Nebraska Passport Questions
          </h2>
          <p className="text-gray-500 text-base leading-relaxed">
            Quick answers for travelers applying for passports across the state of Nebraska.
          </p>
        </div>

        <div className="space-y-4">
          {faqs.map((faq, i) => (
            <details
              key={i}
              className="group bg-white rounded-lg border border-gray-200 overflow-hidden"
            >
              <summary className="flex items-center justify-between cursor-pointer p-5 list-none">
                <span className="font-bold text-[#1A365D] text-sm pr-4">{faq.question}</span>
                <div className="w-7 h-7 flex items-center justify-center rounded-full bg-[#EEF2F8] flex-shrink-0">
                  <i className="ri-add-line text-[#1A365D] text-sm group-open:ri-subtract-line"></i>
                </div>
              </summary>
              <div className="px-5 pb-5">
                <p className="text-gray-500 text-sm leading-relaxed">{faq.answer}</p>
              </div>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
}